<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>

        <div class="col-24 px-3 py-3 col-md-4">
          <section>
            <Profile
              @alterSelectedMenu="alterSelectedMenu"
              :itemMenu="menuSelected"
              :integration="integrationList ? true : false"
            />
          </section>
        </div>

        <div
          v-show="menuSelected == 'home'"
          class="px-3 py-3 mb-5 col-24 col-md-11"
        >
          <div class="col d-column">
            <h1 class="title pt-2 mb-0" v-text="$ml.get('menuAccount')">
              Minha Conta
            </h1>
            <h1 class="title">
              <span v-text="$ml.get('accountSubTitle')" class="pb-2"
                >Uma visão geral e acesso rápido da sua conta só para
                você.</span
              >
            </h1>

            <div class="card mb-3">
              <div class="card-header">
    
                <h6 class="m-0 p-0 light" v-text="$ml.get('publicInformation')">
                  Dados Públicos
                </h6>
              </div>

              <div class="card-body">
                <form v-on:submit.prevent="">
                  <div class="row">
                    <div class="col pr-1">
                      <div class="form-group">
                        <label class="text-muted" v-text="$ml.get('fullName')"
                          >Nome completo</label
                        >
                        <input
                          type="text"
                          :disabled="typeUser == 'hacker'"
                          class="form-control"
                          v-model="name"
                          maxlength="255"
                        />
                        <div name="fade">
                          <label
                            v-if="nameError && !$v.name.required"
                            class="lblError"
                            v-text="
                              $ml
                                .with('f', 3)
                                .with('l', 50)
                                .get('theNameMustBeFromToCharacters')
                            "
                            >O nome deve de 3 a 50 caracteres</label
                          >
                          <label
                            v-if="nameError && !$v.name.minLength"
                            class="lblError"
                            v-text="
                              $ml
                                .with('f', 3)
                                .with('l', 50)
                                .get('theNameMustBeFromToCharacters')
                            "
                            >O nome deve de 3 a 50 caracteres</label
                          >
                          <label
                            v-if="nameError && !$v.name.regexOTN"
                            class="lblError"
                            v-text="$ml.get('nameIsNotValid')"
                            >O nome não é válido</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col pr-1">
                      <div class="form-group">
                        <label class="text-muted">E-mail</label>
                        <input
                          type="text"
                          class="form-control"
                          disabled
                          v-model="email"
                          maxlength="100"
                        />
                      </div>
                    </div>
                  </div>

                  <div v-if="typeUser == 'hacker'">
                    <div class="row">
                      <div class="col pr-1">
                        <div class="form-group">
                          <label class="text-muted" v-text="$ml.get('user')"
                            >Usuário</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            v-model="username"
                            maxlength="100"
                          />
                          <transition name="fade">
                            <label
                              v-if="userError && !$v.username.required"
                              class="lblError"
                              v-text="$ml.get('enterTheUsername')"
                              >Informe o username</label
                            >
                            <label
                              v-if="userError && !$v.username.minLength"
                              class="lblError"
                              v-text="
                                $ml
                                  .with('f', 3)
                                  .with('l', 100)
                                  .get('usernameMustBeFromCharacters')
                              "
                              >O nome de usuário deve de 3 a 100
                              caracteres</label
                            >
                            <label
                              v-if="userError && !$v.username.regexRSC"
                              class="lblError"
                              v-text="$ml.get('usernameMustBeFromCharacters')"
                              >O nome de usuário possui caracteres
                              inválidos</label
                            >
                          </transition>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col pr-1">
                        <div class="form-group">
                          <label class="text-muted" v-text="$ml.get('aboutYou')"
                            >Sobre você</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            v-model="about"
                            maxlength="1000"
                          />
                          <label
                            v-if="userError && !$v.about.regexRSC"
                            class="lblError"
                            v-text="
                              $ml.get(
                                'descriptionCannotContainSpecialCharacters'
                              )
                            "
                            >A descrição não pode conter caracteres
                            especiais</label
                          >
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col pr-1">
                        <div class="form-group">
                          <label class="text-muted">Website</label>
                          <input
                            type="text"
                            ref="website"
                            class="form-control"
                            v-model="website"
                            maxlength="255"
                          />
                          <label
                            v-if="userError && !$v.website.regexURL"
                            class="lblError"
                            >A url do website não é válida</label
                          >
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col pr-1">
                        <div class="form-group">
                          <label class="text-muted">Bugcrowd</label>
                          <input
                            type="text"
                            ref="bugcrowd"
                            class="form-control"
                            v-model="bugcrowd"
                            maxlength="255"
                          />
                          <label
                            class="lblError"
                            v-if="userError && !$v.bugcrowd.regexURL"
                            >A url do bugcrowd não é válida</label
                          >
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col pr-1">
                        <div class="form-group">
                          <label class="text-muted">Hackerone</label>
                          <input
                            type="text"
                            ref="hackerone"
                            class="form-control"
                            v-model="hackerone"
                            maxlength="255"
                          />
                          <label
                            class="lblError"
                            v-if="userError && !$v.hackerone.regexURL"
                            >A url do hackerone não é válida</label
                          >
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col pr-1">
                        <div class="form-group">
                          <label class="text-muted">Linkedin</label>
                          <input
                            type="text"
                            ref="linkedin"
                            class="form-control"
                            v-model="linkedin"
                            maxlength="255"
                          />
                          <label
                            class="lblError"
                            v-if="userError && !$v.linkedin.regexURL"
                            >A url do linkedin não é válida</label
                          >
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col pr-1">
                        <div class="form-group">
                          <label class="text-muted">Twitter</label>
                          <input
                            type="text"
                            ref="twitter"
                            class="form-control"
                            v-model="twitter"
                            maxlength="255"
                          />
                          <label
                            class="lblError"
                            v-if="userError && !$v.twitter.regexURL"
                            >A url do twitter não é válida</label
                          >
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col pr-1">
                        <div class="form-group">
                          <label class="text-muted">Github</label>
                          <input
                            type="text"
                            ref="github"
                            class="form-control"
                            v-model="github"
                            maxlength="255"
                          />
                          <label
                            class="lblError"
                            v-if="userError && !$v.github.regexURL"
                            >A url do github não é válida</label
                          >
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col pr-1">
                        <div class="form-group">
                          <label class="text-muted" v-text="$ml.get('country')"
                            >País</label
                          >
                          <multiselect
                            v-model="selectedCountryOption"
                            :options="countryOptions"
                            :placeholder="$ml.get('selectCountry')"
                            :searchable="true"
                            label="name"
                            :custom-label="nameLang"
                            :close-on-select="true"
                            :show-labels="false"
                            :allow-empty="false"
                            :preselect-first="true"
                            :multiple="false"
                          >
                          </multiselect>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-2">
                      <div class="col-md-12 pr-1">
                        <div class="form-group">
                          <label class="text-muted" v-text="$ml.get('language')"
                            >Idioma</label
                          >
                          <multiselect
                            v-model="selectedLanguageOption"
                            :options="
                              languageOptions.filter(
                                (i) =>
                                  !filterRegisteredLanguages.includes(i.value)
                              )
                            "
                            :placeholder="$ml.get('selectLanguage')"
                            :searchable="true"
                            label="name"
                            :custom-label="nameLang"
                            :close-on-select="true"
                            :show-labels="false"
                            :allow-empty="false"
                            :preselect-first="true"
                            :multiple="false"
                          >
                          </multiselect>
                          <p
                            class="lblError"
                            v-if="language_error"
                            v-text="$ml.get('selectLanguage')"
                          >
                            Selecione um idioma
                          </p>
                        </div>
                      </div>

                      <div class="col-md-12 pr-1">
                        <div class="form-group">
                          <label
                            class="text-muted"
                            v-text="$ml.get('proficiency')"
                            >Proficiência</label
                          >
                          <multiselect
                            v-model="selectLanguageProficiency"
                            :options="proficiencyOptions"
                            :placeholder="$ml.get('selectLanguage')"
                            :searchable="true"
                            label="name"
                            :custom-label="nameLang"
                            :close-on-select="true"
                            :show-labels="false"
                            :allow-empty="false"
                            :preselect-first="true"
                            :multiple="false"
                          >
                          </multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <a href="#" @click="addLanguage()">
                        + {{ $ml.get('additionalMoreLanguages') }}</a
                      >
                    </div>
                    <div v-if="listLanguages.length" class="row mb-2">
                      <div
                        class="col-24 d-flex justify-content-between align-items-center"
                        v-for="(i, index) in listLanguages"
                        :key="index"
                      >
                        <div class="form-group col-10">
                          <label class="text-muted" v-text="$ml.get('language')"
                            >Idioma</label
                          >
                          <multiselect
                            v-model="selectLanguage[i.language]"
                            :options="filterSelectedLanguages(i.language)"
                            :placeholder="$ml.get('selectLanguage')"
                            :searchable="true"
                            label="name"
                            :custom-label="nameLang"
                            :close-on-select="true"
                            :show-labels="false"
                            :allow-empty="false"
                            :preselect-first="true"
                            :multiple="false"
                          >
                          </multiselect>
                        </div>
                        <div class="form-group col-10">
                          <label
                            class="text-muted"
                            v-text="$ml.get('proficiency')"
                            >Proficiência</label
                          >
                          <multiselect
                            v-model="selectedProficiency[i.language]"
                            :options="
                              proficiencyMethod(
                                i.proficiency_level,
                                selectedProficiency[i.language],
                                index
                              )
                            "
                            :placeholder="$ml.get('selectLanguage')"
                            :searchable="true"
                            label="name"
                            :custom-label="nameLang"
                            :close-on-select="true"
                            :show-labels="false"
                            :allow-empty="false"
                            :preselect-first="true"
                            :multiple="false"
                          >
                          </multiselect>
                        </div>
                        <div
                          class="col-2 d-flex justify-content-center remove-icon"
                          @click="removeLanguage(index)"
                        >
                          <svg width="16" height="16">
                            <image
                              xlink:href="../../../src/assets/icons/trash-alt.svg"
                              width="16"
                              height="16"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <button @click="alterName()" class="btn btnForm m-0">
                      <Spinner v-show="loadingNameBtn" />

                      <span v-show="!loadingNameBtn" v-text="$ml.get('save')"
                        >Salvar</span
                      >
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div class="card mb-3" v-if="!ssoIsActive || typeUser === 'hacker' || userBugHunt">
              <div class="card-header">
                <h6 class="m-0 p-0 light">
                  {{ $ml.get('changePassword') }}
                </h6>
              </div>

              <div class="card-body">
                <form v-on:submit.prevent="">
                  <div class="row">
                    <div class="col pr-1 mb-2">
                      <div class="form-group">
                        <label
                          class="text-muted"
                          v-text="$ml.get('oldPassword')"
                          >Senha Antiga</label
                        >
                        <input
                          type="password"
                          v-model="password"
                          class="form-control"
                          placeholder="********"
                          maxlength="200"
                        />
                        <transition name="fade">
                          <label
                            v-if="passwordError && !$v.password.required"
                            class="lblError"
                          >
                            {{ $ml.get('enterThePassword') }}
                          </label>
                          <label
                            class="lblError"
                            v-if="nameError && !$v.password.minLength"
                            >A senha deve conter de 6 a 40 caracteres</label
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col pr-1 mb-2">
                      <div class="form-group">
                        <label class="text-muted">{{
                          $ml.get('newPassword')
                        }}</label>
                        <input
                          type="password"
                          v-model="newPassword"
                          class="form-control"
                          placeholder="********"
                          maxlength="200"
                        />
                        <transition v-if="passwordError" name="fade">
                          <label
                            class="lblError d-inline-block text-truncate w-100"
                          >
                            {{
                              passwordValidation.errorsString
                                ? $ml.get('weakPasswordContain')
                                : ''
                            }}{{ passwordValidation.errorsString }}
                          </label>
                        </transition>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col pr-1 mb-2">
                      <div class="form-group">
                        <label class="text-muted">{{
                          $ml.get('passwordConfirmation')
                        }}</label>
                        <input
                          type="password"
                          v-model="confirmPassword"
                          class="form-control"
                          placeholder="********"
                          maxlength="200"
                        />
                        <transition name="fade">
                          <label
                            v-if="passwordError && !$v.confirmPassword.required"
                            class="lblError"
                            >{{ $ml.get('enterPasswordConfirmation') }}</label
                          >
                          <label
                            v-if="
                              passwordError &&
                              !$v.confirmPassword.sameAsPassword
                            "
                            class="lblError"
                            >{{ $ml.get('passwordsMustMatch') }}</label
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <button @click="alterPassword()" class="btn btnForm m-0">
                      <Spinner v-show="loadingPasswordBtn" />
                      <span
                        v-show="!loadingPasswordBtn"
                        v-text="$ml.get('save')"
                        >Alterar Senha</span
                      >
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <!-- Somente hacker -->
            <div v-if="typeUser == 'hacker'" class="card mb-3">
              <div class="card-header">
                <h6
                  class="m-0 p-0 light fail"
                  v-text="$ml.get('removeAccount')"
                >
                  Remover Conta
                </h6>
              </div>
              <div class="card-body">
                <div
                  class="alert alert-danger"
                  v-text="$ml.get('thisChangeIsIrreversible')"
                >
                  Essa alteração é irreversível.
                </div>
                <div class="row">
                  <button
                    @click="deleteAccount()"
                    class="btn btnForm m-0"
                    style="width: 248px"
                  >
                    <Spinner v-show="loadingDeleteBtn" />
                    <span
                      v-show="!loadingDeleteBtn"
                      v-text="$ml.get('confirmAccountRemoval')"
                      >Confirmar remoção da conta</span
                    >
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <User v-if="menuSelected == 'user'" @updateRoute="menuSelected = 'authentication'" />
        <Company v-if="menuSelected == 'company'" />
        <Plans v-if="menuSelected == 'plans'" />
        <Invoices v-if="menuSelected == 'invoices'" />
        <Revenues v-if="menuSelected == 'revenues'" />
        <Tags v-if="menuSelected == 'tags'" />
        <defaultMessageSetup v-if="menuSelected == 'defaultMessageSetup'" />
        <Access v-if="menuSelected == 'access'" />
        <Vpns v-if="menuSelected == 'vpns'" />
        <Terms v-if="menuSelected == 'terms'" />
        <Locker v-if="menuSelected == 'locker'" />
        <Integration
          v-if="menuSelected == 'integration'"
          :integrationList="integrationList"
        />
        <Authentication v-if="menuSelected == 'authentication'" @updateRoute="menuSelected = 'user'" />
        <AuthenticationCompany v-if="menuSelected == 'authenticationCompany'" />
      </section>
    </main>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { minLength, required, sameAs } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import AccountService from '../../services/account.service';
import PlanService from '../../services/plan.service';

import Company from './company';
import Integration from './integration';
import Invoices from './invoices';
import Plans from './plans';
import Profile from './profile';
import Revenues from './revenues';
import User from './user';
// import Settings from './settings';
import Access from './access';
import Authentication from './authentication';
import defaultMessageSetup from './defaultMessageSetup.vue';
import Locker from "./locker.vue"
import Tags from './tags';
import Terms from './terms';
import Vpns from './vpns';
import AuthenticationCompany from "./authenticationCompany.vue"
import $ from 'jquery';

import {
  listCountries,
  listLanguage,
  listProficiency,
} from '../../helpers/mocks';

import { utils } from '../../utils';

const regexOTN = utils.regexCheck('OTN');
const regexRSC = utils.regexCheck('RSC');
const regexURL = utils.regexCheck('URL');

export default {
  components: {
    Profile,
    User,
    Company,
    Integration,
    Plans,
    Invoices,
    Revenues,
    // Settings,
    Access,
    Tags,
    Vpns,
    Terms,
    Authentication,
    defaultMessageSetup,
    Locker,
    AuthenticationCompany

  },
  data() {
    return {
      ssoIsActive: false,
      userBugHunt: false,
      typeUser: '',
      menuSelected: 'home',
      name: '',
      nameError: false,
      loadingNameBtn: false,
      passwordError: false,
      loadingPasswordBtn: false,
      loadingDeleteBtn: false,
      email: '',

      username: '',
      UserNameCompare: '',
      userError: false,
      about: '',
      bugcrowd: '',
      hackerone: '',
      linkedin: '',
      twitter: '',
      github: '',
      website: '',

      password: '',
      newPassword: '',
      confirmPassword: '',

      rules: [
        { message: 'aNumber', regex: /[0-9]+/ },
        { message: 'anUppercaseLetter', regex: /[A-Z]+/ },
        { message: 'aLowercaseLetter', regex: /[a-z]+/ },
        { message: 'atLeastCharacters', regex: /.{6,}/ },
      ],
      integrationList: false,

      selectedCountryOption: {
        name: 'brasil',
        value: 'br',
      },
      selectedLanguageOption: {
        name: 'selectLanguage',
        value: 'empety',
      },
      selectLanguageProficiency: {
        name: 'basic',
        value: 'basic',
      },
      countryOptions: listCountries,
      languageOptions: listLanguage,
      proficiencyOptions: listProficiency,
      listLanguages: [],
      language_error: false,
      filterRegisteredLanguages: [],

      selectLanguage: {},
      selectedProficiency: {},
    };
  },

  validations: {
    name: { required, regexOTN, minLength: minLength(3) },
    username: { required, regexRSC, minLength: minLength(3) },
    password: { required, minLength: minLength(6) },
    confirmPassword: {
      required,
      sameAsPassword: sameAs('newPassword'),
    },

    about: { regexRSC },
    website: { regexURL },
    bugcrowd: { regexURL },
    hackerone: { regexURL },
    linkedin: { regexURL },
    twitter: { regexURL },
    github: { regexURL },
  },
  computed: {
    ssoEnabled() {
      let enabledSSO = false
       if(this.typeUser === 'company'){
        enabledSSO = this.$store.getters["getUser"]?.ssoSettings?.enabled;
       }
        return enabledSSO
    },
    passwordValidation() {
      let errorsString = '';

      for (let condition of this.rules) {
        if (!condition.regex.test(this.newPassword)) {
          errorsString = errorsString + this.$ml.get(condition.message);
        }
      }

      return { errorsString };
    },
  },

  mounted() {
    if(this.$route.params.locker === 'locker_onboarding'){
          this.menuSelected = 'locker';                  
    }
    if (this.$route.fullPath.split('?')[1]) {
      this.alterSelectedMenu(this.$route.fullPath.split('?')[1]);
    }

    this.name = this.$store.getters['getUser'].name;
    this.email = this.$store.getters['getUser'].email;
    this.typeUser = this.$store.getters['getUserType'];
    if (this.typeUser == 'hacker') {
      this.changeDetailsHacker();
    } else {
      this.changeIntegrationList();
    }
    this.changeDados(this.typeUser);

    if(this.typeUser === 'company'){
      this.ssoIsActive = this.$store.getters["getUser"].ssoSettings.enabled
    }
  },
  watch: {
  ssoEnabled() {
    this.ssoIsActive = this.ssoEnabled
  },

    selectedLanguageOption() {
      this.language_error = false;
    },
  },
  beforeUpdate() {
    console.log(this.filterRegisteredLanguages);
  },
  methods: {
    updateListLanguages(index, newValue) {
      this.listLanguages[index].proficiency_level = newValue?.name;
    },

    proficiencyMethod(value, newValue, index) {
      let selectLanguage = this.proficiencyOptions.filter(
        (it) => it.value == value
      );
      let filterAll = this.proficiencyOptions.filter((it) => it.value != value);
      let newList = [...selectLanguage, ...filterAll];

      this.updateListLanguages(index, newValue);

      return newList;
    },

    filterSelectedLanguages(value) {
      let selectLanguage = this.languageOptions.filter(
        (it) => it.value == value
      );
      let filterAll = this.languageOptions.filter(
        (i) => !this.filterRegisteredLanguages.includes(i.value)
      );
      let newList = [...selectLanguage, ...filterAll];
      return newList;
    },
    ...mapActions(['setUser', 'resetUser', 'setAmountPrograms']),
    alterSelectedMenu(menu) {
      this.menuSelected = menu;
    },

    changeIntegrationList() {
      PlanService.getCurrentPlanByCompany().then((response) => {
        let resp = response;
        if (resp.data.integration_types) {
          this.integrationList = resp.data.integration_types;
        }
      });
    },

    changeDados(type) {
      var self = this;

      AccountService.getAccountMy().then((response) => {
        if (type == 'company') {
            const {enabled} = response.data.ssoSettings;
            this.ssoIsActive = enabled;

        if(response.data.email.split('@')[1] === 'bughunt.com.br'){
            this.userBugHunt = true;
        }

          self.setUser({
            account_avatar: response.data.account_avatar,
            account_createdAt: response.data.account_createdAt,
            companyName: response.data?.companyName,
            company_avatar: response.data?.company_avatar,
            company_settings: response.data?.settings,
            company_createdAt: response.data.company_createdAt,
            email: response.data.email,
            name: response.data.name,
            role: response.data?.role,
          });
          self.setAmountPrograms(response.data.amount_of_programs);
        } else {
          self.setUser({
            account_avatar: response.data.account_avatar,
            name: response.data.name,
            email: response.data.email,
            username: response.data?.username,
            verified: response.data?.verified,
            paypal_account: response.data?.paypal_account,
            amount_of_reports: response.data?.amount_of_reports,
            score: response.data?.score,
          });
          this.listLanguages = response.data?.spoken_languages
            ? response.data?.spoken_languages
            : [];
        }
      });
    },

    changeDetailsHacker() {
      AccountService.getAccountDetails().then((response) => {
        let resp = response.data;
        this.name = resp.name;
        this.username = resp.username;
        this.UserNameCompare = resp.username;
        this.about = resp.about;
        this.bugcrowd = resp.external_links.bugcrowd;
        this.hackerone = resp.external_links.hackerone;
        this.linkedin = resp.external_links.linkedin;
        this.twitter = resp.external_links.twitter;
        this.website = resp.external_links.website;
        this.github = resp.external_links.github;
      });
    },

    removeNullFields(obj) {
      const result = {};
      for (const key of Object.keys(obj)) {
          if (obj[key] !== null) {
              result[key] = obj[key];  
          }
      }
      return result;
    },

    alterName() {
      document.activeElement.blur();
      var self = this;
      // stop here if form is invalid
      this.$v.$touch();
      this.$v.$reset();
      if (this.$v.name.$invalid) {
        this.nameError = true;

        Swal.fire({
          icon: 'info',
          title: '',
          text: self.$ml.get('checkOutAllFieldsHighlightedInRed'),
        });
        $('html, body').animate({ scrollTop: 0 }, '5000');

        return;
      }

      this.loadingNameBtn = true;
      this.nameError = false;

      if (this.typeUser == 'company') {
        AccountService.putAccount({
          name: this.name.trim(),
        }).then(
          () => {
            this.loadingNameBtn = false;
            this.$store.dispatch('setUser', {
              name: this.name.trim(),
            });
            Swal.fire({
              icon: 'success',
              title: self.$ml.get('nameChanged'),
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
            });
            this.setUser({
              name: this.name.trim(),
            });
          },
          () => {
            this.loadingNameBtn = false;
          }
        );
      } else {
        if (
          this.$v.about.$invalid ||
          this.$v.username.$invalid ||
          this.$v.website.$invalid ||
          this.$v.bugcrowd.$invalid ||
          this.$v.hackerone.$invalid ||
          this.$v.linkedin.$invalid ||
          this.$v.twitter.$invalid ||
          this.$v.github.$invalid
        ) {
          this.userError = true;
          this.loadingNameBtn = false;
          return;
        }

        let payload = {
          name: this.name.trim(),
        };
        payload.name = this.name.replace(/\s\s+/g, ' ');

        payload.username = this.username.trim();
        payload.username = this.username.replace(/\s\s+/g, ' ');

        payload.country = this.selectedCountryOption.value;
        payload.spoken_languages = this.listLanguages;
        this.about ? (payload.about = this.about) : (payload.about = null);
        this.website
          ? (payload.website = this.website)
          : (payload.website = null);
        this.bugcrowd
          ? (payload.bugcrowd = this.bugcrowd)
          : (payload.bugcrowd = null);
        this.hackerone
          ? (payload.hackerone = this.hackerone)
          : (payload.hackerone = null);
        this.linkedin
          ? (payload.linkedin = this.linkedin)
          : (payload.linkedin = null);
        this.twitter
          ? (payload.twitter = this.twitter)
          : (payload.twitter = null);
        this.github ? (payload.github = this.github) : (payload.github = null);

        this.userError = false;

        payload = this.removeNullFields(payload);
    

        AccountService.putAccountHacker(payload).then(
          () => {
            this.loadingNameBtn = false;
            Swal.fire({
              icon: 'success',
              title: self.$ml.get('dataChanged'),
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
            });           
            this.setUser({
              name: payload.name,
              username: payload.username,
            });
            this.changeDetailsHacker();
          },
          (error) => {
            this.loadingNameBtn = false;
            const resp = error.response.data;
            console.log('error.......');
            console.log(resp.message[0]);
            switch (resp.message[0]) {
              case 'website':
                this.$refs.website.focus();
                break;
              case 'bugcrowd':
                this.$refs.bugcrowd.focus();
                break;
              case 'hackerone':
                this.$refs.hackerone.focus();
                break;
              case 'linkedin':
                this.$refs.linkedin.focus();
                break;
              case 'twitter':
                this.$refs.twitter.focus();
                break;
              case 'github':
                this.$refs.github.focus();
                break;
            }

            Swal.fire({
              icon: 'info',
              html: `<h4 class="mb-1">${self.$ml.get(
                'usernameIsNotAvailable'
              )}</h4> 
              <label> 
              </label>  
              `,
              showConfirmButton: false,
              timer: 5000,
            });
          }
        );
      }
    },

    alterPassword() {
      var self = this;
      // stop here if form is invalid
      this.$v.$touch();
      if (
        this.$v.password.$invalid ||
        this.$v.confirmPassword.$invalid ||
        this.passwordValidation.errorsString
      ) {
        this.passwordError = true;
        return;
      }

      this.passwordError = false;

      if (this.newPassword != this.confirmPassword) {
        Swal.fire({
          icon: 'info',
          text: self.$ml.get('newPasswordAndConfirmation'),
          showConfirmButton: false,
          timer: 5000,
        });
        this.confirmPassword = '';
        return;
      }

      this.loadingPasswordBtn = true;

      AccountService.postAccountPassword({
        currentPassword: this.password,
        newPassword: this.newPassword,
      }).then(
        () => {
          this.loadingPasswordBtn = false;
          this.password = '';
          this.newPassword = '';
          this.confirmPassword = '';
          Swal.fire({
            icon: 'success',
            title: self.$ml.get('passwordChanged'),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });
        },
        () => {
          this.loadingPasswordBtn = false;
          Swal.fire({
            icon: 'info',
            title: self.$ml.get('invalidPassword'),
            showConfirmButton: false,
            timer: 5000,
          });
        }
      );
    },

    deleteAccount() {
      document.activeElement.blur();
      var self = this;

      Swal.fire({
        html: `<h4 class="mb-1">${self.$ml.get(
          'doYouReallyWantToRemoveThisAccount'
        )}</h4> 
              <label>
                ${self.$ml.get('toConfirmWeNeedYourPassword')}
              </label>  
              `,
        input: 'password',
        inputPlaceholder: self.$ml.get('enterThePassword'),
        inputAttributes: {
          maxlength: 200,
          autocapitalize: 'off',
          autocorrect: 'off',
        },
        customClass: 'swal-2fa',
        showCancelButton: true,
        confirmButtonText: self.$ml.get('remove'),
        cancelButtonText: self.$ml.get('cancel'),
        confirmButtonColor: '#730BA9',
        preConfirm: (resp) => {
          AccountService.deleteAccount({
            password: resp,
          }).then(
            async () => {
              Swal.fire({
                icon: 'success',
                title: self.$ml.get('accountDeleted'),
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
              });

              setTimeout(() => {
                self.resetUser();
                localStorage.removeItem('token_safe');

                self.$router.push('/login');
              }, 2000);
            },
            () => {
              Swal.fire({
                icon: 'warning',
                title: self.$ml.get('unableToCompleteThisRequest'),
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
              });
            }
          );
        },
      });
    },
    addLanguage() {
      if (
        !this.selectedLanguageOption ||
        this.selectedLanguageOption.value === 'empety'
      ) {
        this.language_error = true;
        return;
      }
      this.listLanguages = [
        ...this.listLanguages,
        {
          language: this.selectedLanguageOption.value,
          proficiency_level: this.selectLanguageProficiency.value,
        },
      ];
      this.filterRegisteredLanguages = this.listLanguages.map(
        (i) => i.language
      );
      this.selectedLanguageOption = '';
    },
    removeLanguage(id) {
      this.listLanguages.splice(id, 1);
      this.filterRegisteredLanguages = this.listLanguages.map(
        (i) => i.language
      );
    },
    nameLang({ name }) {
      return `${this.$ml.get(name)}`;
    },
  },
};
</script>
<style scoped>
.box-tag {
  display: flex;
  align-items: center;
  border: 1px solid #ced4da;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
}
.box-tag ul li {
  margin: 5px;
}
.tag-wrapper {
  padding: 8px;
  background-color: #fefdff;
  color: #730ca8;
  font-size: 13px;
  border: 2px solid #730ca8;
  border-radius: 10rem;
  font-weight: 500;
}
.tag-title {
  font-size: 0.85rem;
  padding: 0px;
  margin: 0px;
}
.remove-icon {
  cursor: pointer;
}
</style>
